// REQUIRE 12 wide by 6 tall
// 12 items, 3 rows x 4 columns
export const AsciiCommons: { [key: string]: string[] } = {
  blank: [
    `             `,
    `             `,
    `             `,
    `             `,
    `             `,
    `             `,
  ],
  bottle: [
    "     mm     ",
    "     )(     ",
    "    (  )    ",
    "    |  |    ",
    "    |  |    ",
    "    |__|    ",
  ],
  camera: [
    "            ",
    "  _n_||_,_  ",
    " |===..===| ",
    " |  (())  | ",
    " '===''===' ",
    "            ",
  ],
  candle: [
    "    )       ",
    "   (_)      ",
    "   |`|      ",
    "   | |  _() ",
    " \\_|_|_/    ",
    "            ",
  ],
  coffeecup: [
    "            ",
    "    ;)( ;   ",
    "   :----:   ",
    "  C|====|   ",
    "   |    |   ",
    "   `----'   ",
  ],
  dice: [
    "   _____    ",
    "  / .  /\\   ",
    " /____/..\\  ",
    " \\'  '\\  /  ",
    "  \\'__'\\/   ",
    "            ",
  ],
  drum: [
    " ===o  o=== ",
    "  ________  ",
    " |________| ",
    "  |\\  /\\ |  ",
    "  | \\/__\\|  ",
    " |________| ",
  ],
  feather: [
    "            ",
    "   (`/\\     ",
    "   `=\\/\\    ",
    "    `=\\/\\   ",
    "     `=\\/   ",
    "        \\   ",
  ],
  flower: [
    "    _.._    ",
    "   (_\\\\_)   ",
    "  (__<__{}  ",
    "   (_//_)   ",
    "     ||     ",
    "     ||/    ",
  ],
  hammer: [
    "   ______   ",
    "  |_,.,--\\  ",
    "     ||     ",
    "     ||     ",
    "     ##     ",
    "     ##     ",
  ],
  hourglass: [
    "   .____.   ",
    "   |(__)|   ",
    "   | )( |   ",
    "   |(::)|   ",
    "   .____.   ",
    "            ",
  ],
  leaf: [
    "     ||     ",
    "   .'||'.   ",
    "  /.'||\\ \\  ",
    "  | /||'.|  ",
    "   \\ ||\\/   ",
    "    \\||/    ",
  ],
  phone: [
    "  ________  ",
    " (_]----[_) ",
    ".~ |.''.|   ",
    "~. |'..'|   ",
    " `~`----`   ",
    "            ",
  ],
  pineapple: [
    "            ",
    "    \\||/    ",
    "    AXXA    ",
    "   /XXXX\\   ",
    "   \\XXXX/   ",
    "    `^^'    ",
  ],
  pocketknife: [
    "       _    ",
    "     /|o|   ",
    "    / | |   ",
    "   / /| |   ",
    "  / / |+|   ",
    " /.'  [_]   ",
  ],
}

// REQUIRE 13 wide by 6 tall
// 12 items, 3 rows x 4 columns
export const AsciiMythics: { [key: string]: string[] } = {
  blank: [
    `             `,
    `             `,
    `             `,
    `             `,
    `             `,
    `             `,
  ],
  ant: [
    "            ",
    "  _  _  ,,  ",
    " (_)(_)-O   ",
    "  L L L     ",
    " `````--..  ",
    "            ",
  ],
  bee: [
    "      __    ",
    "     // \\   ",
    "     \\\\_/ //",
    "... -(||)(')",
    "    '''     ",
    "            ",
  ],
  butterfly: [
    "            ",
    "    \\  /    ",
    "  (.\\\\//.)  ",
    "   \\ () /   ",
    "   (_/\\_)   ",
    "            ",
  ],
  canary: [
    "    .-.     ",
    "   /'v'\\    ",
    "  (/   \\)   ",
    ' =\'="="===< ',
    "    |_|     ",
    "            ",
  ],
  chicken: [
    ' /""\\      ,',
    "<>^  L____/|",
    " `) /`   , /",
    "  \\ `---' / ",
    "   `'\";\\)`  ",
    "     _/_Y   ",
  ],
  duck: [
    "            ",
    "   _        ",
    " >(')____,  ",
    "   (` =~~/  ",
    "~^~^`---'~^~",
    "            ",
  ],
  eagle: [
    "  .`.   _ _ ",
    "__;_ \\ /,//`",
    "--, `._) (  ",
    " '//,,,  |  ",
    "      )_/   ",
    "     /_|    ",
  ],
  falcon: [
    "     __     ",
    "    /'{>    ",
    "  ___)(___  ",
    " /'-;  ;-'\\ ",
    "////\\__/\\\\\\\\",
    "     mm     ",
  ],
  frog: [
    "            ",
    "    ()()    ",
    "  .-(__)-.  ",
    "   _<  >_   ",
    "   \\/  \\/   ",
    "            ",
  ],
  owl: [
    "            ",
    "    ,_,     ",
    "   (O,O)    ",
    "   (   )    ",
    '   -"-"--   ',
    "            ",
  ],
  parakeets: [
    "      \\\\    ",
    " \\\\   (o>   ",
    " (o>  //\\   ",
    "_(()__V_/___",
    " ||   ||    ",
    "      ||    ",
  ],
  parrot: [
    "            ",
    "     (@>    ",
    "    {||     ",
    '   --""--   ',
    "     ||     ",
    "     ||     ",
  ],
  penguin: [
    "    __      ",
    " -=(o '.    ",
    "    '.-.\\   ",
    "    /|  \\\\  ",
    "    '|  ||  ",
    "     _\\_):,_",
  ],
  spider: [
    "            ",
    "   ||  ||   ",
    "   \\\\()//   ",
    "  //(__)\\\\  ",
    "  ||    ||  ",
    "            ",
  ],
}

// REQUIRE 74 wide by 28 tall
// key (start colors, should start very pale):
//   y = yellow
//   r = red
//   m = magenta
//   u = blue
//   c = cyan
//   g = green
//   w = white
//   k = black
export const TapestryArt = [
  "",
  "",
  "    y*                y*         y*                   y*",
  "          y*                      y*        y*                         y*",
  "  y*             y*                                         y*             y*",
  "     y*             m_m_m_",
  "                 m_m/cXcXcXm\\        y*",
  "                m/cXcXcXcXcXcXm\\m_                                    m_m_         y*",
  "  m\\m_m_    m_m_    m/cX cXcXcXcX cXcXm\\               y*          m_       m/cXcXm\\m_m_   y*",
  "      m\\m_m_m/  m\\m_m/m_m_       m\\ m\\                       m_m/cXm\\m_m_   m/cXcX cXcXcXm\\m_m_m_m_m/cXcXcXm\\",
  "    m\\  m_m_m_   m\\m/  m\\m_      m\\ m\\               m_m_   m_m/      m\\m_m/  m_m/  m-   m_m_  m-  ",
  "   r_r_r_r/   r\\r_r_r/   r\\ r\\r_r_     r\\r\\    y*        r/  r\\r_r/r/  r_ r_ r\\  r\\     r_r_  r/  r\\r_r_r_r_",
  "  r/  r_r_    r\\  r/     r\\ r\\r_   r_r/r/r_r\\r_r_r_     r_r/    r/r/           r\\r_r_r_r/  r\\r/     r_r_r/",
  "  b_b_b/b_b_b_b_b_b_b_b\\b_b_b_b_b_b_b_b_b\\b_b_b\\b_b/b_b_b_b_b_b_b_b_b\\b_ b_b/b_b_b_b_b_b/b_b_b_b_b_b_b_b_b_b_b_b_b_b/b_b_b_b_b_b_b_b\\b_b_b_b_b/b_b_b_",
  "                                    c/c|c\\",
  "     g|g|                            c/ c| c\\                         y*",
  "     g|g|      y*                    c/  c|  c\\              g|        y*g|y*",
  "  g|g| g|g|     y*g|y*                  c/   c|   c\\            g|g|g.",
  "  g|g| g|g|                         c/    c|    c\\           g`g|g|",
  "  g|g| g|g|  g|g|                    c/     c|     c\\           g|g'               g|",
  "   g\\g\\g|g|  g|g|        r*          c/      c|      c\\          g|               g|g|g.",
  "    g\\g|g| g/g/        r*g|r*        c/       c|       c\\        y;y;y;              g`g|g|",
  "     g|g|g/g/                   c/        c|        c\\            y(y(y_y)y)        g|g'",
  "     g|g|g/                   c/         c|         c\\           y(yo yoy)        g|",
  "     g|g|                   c/          c|          c\\           y\\y_y/        y;y;y;",
  "     g|g|     y_y_yQyQ       r_r_r_      y_   m_  c_c_ y_y_y_ r_",
  '    y;y;y;y;   y(y_y)y_y"y>       r|  g/g\\  y|y_y) m|m_ c(c_   y| r|r_r) g\\g_g/',
  "           y_y)           r| g/g-g-g\\ y|   m|m_ c_c_c)  y| r| r\\  g|",
  "",
]
